<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Tax Groups</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" small to="/tax-groups/create">
              <v-icon left dark>mdi-plus</v-icon>New Tax Group
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :loading="loading"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="taxGroups"
              :search="search"
            >
              <template v-slot:item.view="{ item }">
                <v-btn
                icon
                  :to="`/tax-groups/details/${item.id}`"
                  text
                  color="accent"
                >
                <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>

              <template v-slot:item.tax_type="{ item }">
                <span>{{ item.tax_type === 1 ? "Sales Tax" : "Purchases Tax" }}</span>
              </template>

            </v-data-table>
          </v-col>
        </v-row>

        <!-- Outsourced dialog -->
        <v-dialog v-model="editDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="accent" dark>
              <v-toolbar-title>Edit Tax Group</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="editDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid class="subtitle-2 text--primary">
                <v-row>
                  <v-col cols="12" xs="12" md="16">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      v-model="editItem.Name"
                      label="Tax Group Name"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="5" xs="5" md="4">
                    <v-text-field
                      autocomplete="off"
                      type="number"
                      v-model="editItem.Rate"
                      label="Tax Rate(%)"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="accent" @click="save" :loading="loader">
                      <v-icon left>mdi-content-save</v-icon>Update
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of outsourced modal-->
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    loading: false,
    editItem: {},
    loader: false,
    editDialog: false,
    taxGroups: [],
    headers: [
      { text: "Name", value: "name" },
      { text: "Rate", value: "rate" },
      { text: "Category", value: "tax_type" },
      { text: "Action", value: "view" }
    ]
  }),
  methods: {
    getTaxes() {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("get", `/tax-group`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.taxGroups = res.ResponseData;
            self.loading = false;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getTaxes();
  }
};
</script>